import {
    IConfigFieldDefinition,
} from './fields-definitions/config-field-definition-base';

export class ConfigurationArea {
    constructor(private _title: string, private _fields: IConfigFieldDefinition[]) {

    }

    get title(): string {
        return this._title;
    }

    get fields(): IConfigFieldDefinition[] {
        return this._fields;
    }
}